const sunDisc = document.getElementById('sun_disc')

if (sunDisc) {
  timelineAnimation()
}

function timelineAnimation () {
  gsap.registerPlugin(ScrollTrigger)
  const listItems = document.querySelectorAll('.js_timeline_item')

  const firstItem = listItems[0]
  const lastItem = listItems[0]
  const topOffsetFirstEl = firstItem.getBoundingClientRect().top
  const bottomOffsetLastEl = lastItem.getBoundingClientRect().bottom + 500

  firstItem.classList.add('active')

// Create a ScrollTrigger for each list item
  listItems.forEach((item, i) => {

    ScrollTrigger.create({
      trigger: item,

      start: self => {
        if (self.trigger.classList.contains('first-item')) {
          // First list item start from top of the page
          return `-${topOffsetFirstEl}px center`
        }
        else {
          return 'top center'
        }
      },
      end: self => {
        if (self.trigger.classList.contains('last-item')) {
          // Last list item ends on bottom of the page
          return `${bottomOffsetLastEl}px center`
        }
        else {
          return 'bottom center'
        }
      },
      // markers: true,
      onEnter: () => {
        item.classList.add('active')
        const itemPosition = item.offsetTop - sunDisc.offsetHeight / 2 + item.offsetHeight / 2
        moveSunDisc(itemPosition)
      },
      onLeave: () => {
        item.classList.remove('active')
      },
      onEnterBack: () => {
        item.classList.add('active')
        const itemPosition = item.offsetTop - sunDisc.offsetHeight / 2 + item.offsetHeight / 2
        moveSunDisc(itemPosition)
      },
      onLeaveBack: () => {
        item.classList.remove('active')
      }
    })
  })

  function moveSunDisc (position) {
    gsap.to(sunDisc, { top: position, duration: 0.5, ease: 'power2.out' })
  }
}

